<template>
  <div class="dashboard-profile-card">

    <div class="dashboard-profile-image-container">
        <img v-if="profileUrl" v-bind:src="profileUrl" alt="Profile image"/>
        <img v-else src="../assets/images/image-placeholder.png" alt="A placeholder image" />
    </div>

    <div class="dashboard-profile-info">
        <div class="dashboard-profile-name">{{userName}}</div>
        <div class="dashboard-profile-user-type">{{userType}}</div>
        <div v-if="userLocation && userLocation !== ''" class="dashboard-profile-user-location">
          <!-- <img class="location-icon" src="../assets/images/location-marker.svg" alt="Location marker"/> -->
          <div>{{userLocation}}</div>
        </div>
    </div>

    <button class="dashboard-create-job-btn" @click="$emit('backToPostJob', 'Post Job')">
      <div>Create a Job</div>
      <img class="job-create-icon" src="../assets/images/profile-plus.svg" alt="Create Job"/>
    </button>

  </div>
</template>

<script>

export default {
  name: 'DashboardProfileCard',
  props:[
    'profileUrl',
    'userName',
    'userType',
    'userLocation'
  ],
  beforeMount(){
  }
};
</script>

<style scoped>
  .dashboard-profile-card {
    border-radius:15px;
    display:flex;
    flex-direction:column;
    font-size: 1rem;
    align-items:center;
    justify-content:center;
    width:100%;
    height:100%;
    text-align:center;
  }

  .dashboard-profile-image-container {
    width: 180px;
    height: 180px;
  }

  .dashboard-profile-image-container img {
    object-fit:cover;
    width:100%;
    height:100%;
    border-radius:100%;
  }

  .dashboard-profile-card .dashboard-profile-name {
    font-weight: 700;
    color: var(--colorSecondary);
    line-height: 1.905rem;
    font-size: 1rem;
    text-transform: uppercase;
  }

  .dashboard-profile-info {
    margin-top:1.938rem;
  }

  .dashboard-profile-card .dashboard-profile-user-type {
    margin-top: 10px;
    font-weight: 600;
    color: #828282;
    line-height: 1.524;
    font-size: 0.9rem;
    text-transform: uppercase;
  }

  .dashboard-profile-user-location {
    margin-top: 1.438rem;
    color: var(--colorPrimary);
    display: flex;
    font-size: 0.9rem;
    padding: 0 20px;
    justify-content: center;
  }

  .dashboard-profile-user-location img {
    width:20px;
    height:20px;
  }

  .dashboard-create-job-btn {
    margin-top:45px;
    font-size:1.125rem;
    font-weight:600;
    background:var(--colorPrimary);
    border:none;
    display:flex;
    align-items:center;
    color:var(--white);
    padding:16px 32px;
    border-radius:5px;
  }

  .dashboard-create-job-btn img{
    width:15px;
    padding-right:14px;
  }

  /* .dashboard-create-job-btn div{
    padding-right:14px;
  } */

  @media only screen and (max-width:1178px) {
    .dashboard-profile-image-container{
      width: 100px;
      height: 100px;
    }

    .dashboard-profile-card .dashboard-profile-name {
      line-height: 1.219rem;
      /* font-size: calc(1.563rem/1.2); */
    }

    /* .dashboard-profile-card .dashboard-profile-user-type {
      font-size:calc(1.25rem / 1.2);
    } */

    .dashboard-profile-user-location {
      font-size:12px;
    }

    .dashboard-profile-user-location img {
      width:15px;
      height:15px;
    }

    .dashboard-create-job-btn{
      font-size:calc(1.125rem/1.2);
      padding:14px 40px;
    }

  }

  @media only screen and (max-width:1078px) {
    .dashboard-profile-image-container{
      width: 100px;
      height: 100px;
    }

    .dashboard-profile-card .dashboard-profile-name {
      line-height: 1.219rem;
      /* font-size: calc(1.563rem/1.2); */
    }

    /* .dashboard-profile-card .dashboard-profile-user-type {
      font-size:calc(1.25rem / 1.2);
    } */

    .dashboard-profile-user-location {
      font-size:12px;
    }

    .dashboard-profile-user-location img {
      width:15px;
      height:15px;
    }

    .dashboard-create-job-btn {
      font-size:calc(1.125rem/1.2);
      padding:14px 40px;
    }
  }

  @media only screen and (max-width:990px) {
    .dashboard-profile-image-container {
      width: 100px;
      height: 100px;
    }

    .dashboard-profile-card .dashboard-profile-name {
      line-height: 1.219rem;
    }

    /* .dashboard-profile-card .dashboard-profile-user-type {
      font-size:calc(1.25rem / 1.2);
    } */

    .dashboard-profile-user-location {
      font-size:12px;
    }

    .dashboard-profile-user-location img {
      width:15px;
      height:15px;
    }

    .dashboard-create-job-btn {
      font-size:calc(1.125rem/1.2);
      padding:14px 40px;
    }

    .dashboard-create-job-btn img {
      width:25px;
      padding-right:10px;
    }
  }

  @media only screen and (max-width: 767px) {
    .dashboard-profile-card {
      padding: 1.4rem 0;
      height: unset;
    }
  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }
</style>
